<template>
  <article class="question_area">
    <div class="article_head">
      <div class="ttl_wrap">
        <h3>
          <span class="red" v-if="data.isHot === 'Y'">HOT</span>
          <span v-if="data.category">{{ categories[data.category] }}</span>
          <span class="red02" v-if="isNew(data.createdAt)">NEW</span>
          {{ data.title }}
        </h3>
      </div>
      <div class="info_zone">
        <div class="sec_1">
          <span>{{ data.writer }}</span>
          <span v-if="boardType === 'KNOWHOW' && data.areaFullName">
            | {{ data.areaFullName }}</span
          >
          <span
            class="light spare-04 pnt"
            @click="fnReport"
            v-if="data.isMine === 'N'"
            >신고하기</span
          >
        </div>
        <div class="sec_2">
          <div class="left">
            <span class="light">{{ data.createdAt | moment('from') }}</span>
          </div>
          <div class="right">
            <span><i class="i_list_like"></i>{{ data.likeCnt }}</span>
            <span><i class="i_list_eye"></i>{{ data.readCnt }}</span>
            <span><i class="i_list_reply"></i>{{ data.replyCnt }}</span>
          </div>
        </div>
      </div>
    </div>
    <hr class="m0" />
    <div class="article_content">
      <p class="txt">
        {{ data.contents }}
      </p>
      <div class="img_box big" v-if="data.images?.length > 0">
        <img
          class="pnt"
          v-for="(item, index) in data.images"
          :key="item.id"
          :src="item.imagePath"
          alt=""
          @click="viewImage(data.images, index)"
        />
      </div>
    </div>
    <div class="like_btn">
      <button :class="{ on: data.isLike === 'Y' }" @click="fnLike">
        <i :class="`i_reply_like_${data.isLike === 'Y' ? 'on' : 'off'}`"></i
        >{{ data.likeCnt }}
      </button>
    </div>
    <MultipleImageModal
      ref="multipleImageModal"
      :is-open="isShowImageModal"
      :urls="clickedImageUrls"
      :index="clickedImageIndex"
      @close="closeImageModal"
    />
  </article>
</template>

<script>
import MultipleImageModal from '@/common/components/modal/MultipleImage.vue';
import 'swiper/swiper.scss';

import {
  sleep,
  connectedSocket,
  closeSocket,
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  jsonEscape,
  toBR,
} from '@common/lib/common/utils';

export default {
  name: 'component-community-detail-section-question',
  description: '커뮤니티 > 질문 영역',
  components: {
    MultipleImageModal,
  },
  props: {
    boardType: {
      type: String,
      default: 'KNOWHOW',
      description: 'KNOWHOW: 지식인, BOARD: 자유게시판',
    },
    data: Object,
  },
  data() {
    return {
      categories: {
        MOBILE: '휴대폰',
        INTERNET: '인터넷',
        MVNO: '알뜰폰',
        PLAN: '요금제',
        RENTAL: '렌탈',
        STORE: '매장',
      },
      isShowImageModal: false,
      clickedImageUrls: [],
      clickedImageIndex: 0,
    };
  },
  methods: {
    fnReport() {
      this.$emit('report', 'POST_REPORT', this.data);
    },
    fnLike() {
      this.$emit('like', this.data, 'POST');
    },
    isNew(createdAt) {
      const now = this.$moment().format('YYYY-MM-DD HH:mm:ss');
      const create_24 = this.$moment(createdAt)
        .add(1, 'days')
        .format('YYYY-MM-DD HH:mm:ss');
      return now < create_24;
    },
    viewImage(images, idx) {
      // console.log(images);
      // alert('idx = ' + idx);
      this.isShowImageModal = true;
      this.clickedImageUrls = images;
      this.clickedImageIndex = idx;
      this.$refs.multipleImageModal.imageClickIndex = idx;
      nativeDisableBackKey();
    },
    closeImageModal() {
      this.isShowImageModal = false;
      this.clickedImageUrls = [];
      this.clickedImageIndex = 0;
      nativeEnableBackKey();
    },
  },
};
</script>

<style></style>
